/// <reference types="@angular/localize" />
import { enableProdMode, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { createApplication } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

createApplication({
  providers: [
    provideRouter(routes), 
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),
    provideBrowserGlobalErrorListeners(),
    importProvidersFrom(AppModule)
  ]
})
  .then((appRef) => {
    return appRef.bootstrap(AppComponent); 
  })
  .catch((err) => console.error(err));

